/** @jsxImportSource @emotion/react */
import { Button, CircularProgress } from "@mui/material";
import { makeStyles } from "@mui/styles";
import PropTypes from "prop-types";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: "2px",
    width: "90px",
  },
}));

/**
 * Fundamental component for action buttons on the EmployeeTradeTable 'Actions' column
 * and UserAccessOverrideEventTable 'Edit' column.
 * @param {*} props - see propTypes below for more details
 * @returns
 */
const ActionButton = (props) => {
  const classes = useStyles();
  return (
    <Button
      className={`${props.className} ${classes.root}`}
      variant={props.variant}
      color={props.color}
      onClick={props.onClick}
      disabled={props.isLoading ? true : false}
    >
      {props.isLoading ? <CircularProgress size={24} /> : props.children}
    </Button>
  );
};

ActionButton.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string.isRequired,
  color: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  isLoading: PropTypes.bool,
  children: PropTypes.string.isRequired,
};

export default ActionButton;
